import Grid2 from '@mui/material/Unstable_Grid2/Grid2';
import { concat, get } from 'lodash';
import React, { FC } from 'react';
import CreateForm from 'src/components/ui-component/form-component/create-form/CreateForm';
import { useApplication } from 'src/context/ApplicationContext';
import { ALS_ERLEDIGT_MARKIEREN_LABEL, PLATZHALTER_TEXT } from 'src/lib/constants/constant';
import { FormStrucItem } from 'src/lib/types/types';
import {
	ForceTrue,
	GetCompareMinMaxEqualDate,
	GetDateGTMaxYearValidation,
	GetFutureDateValidation,
	Required,
	ValidDate,
} from 'src/lib/validation/ValidationTypes';
import { checkReadOnlyInUeberarbeitung } from 'src/utils/helper';
import PruefAssistenz from '../../../../antrag-components/PruefAssistenz';
import ApplicationHeading from '../../../../application-heading/ApplicationHeading';
import { checkIfPruefAssitenzNeedsToValidate } from '../../../../application-helper-function/AppHelperfunctions';

// import schemas
import Schema from 'src/lib/paths/antrag_FULL_Paths.json';
const P = Schema.attributes;

const MessebeteiligungMessefoerderung: FC<{ hasComment?: boolean }> = ({ hasComment }) => {
	const { application, setApplicationProperty, readOnly } = useApplication();
	const updatedReadOnly = checkReadOnlyInUeberarbeitung(application, readOnly, hasComment);
	return (
		<>
			<ApplicationHeading title='Angaben zur Messebeteiligung' description={PLATZHALTER_TEXT} />

			<PruefAssistenz
				statusPath={P.Angaben_Zur_Messebeteiligung.schema.attributes.Angaben_Zur_Messebeteiligung_Pruefung_Pruefstatus.path}
				hinweisPath={P.Angaben_Zur_Messebeteiligung.schema.attributes.Angaben_Zur_Messebeteili_0142701586_nweis_Fuer_Den_Antragsteller.path}
				ueberarbeitetAmPath={P.Angaben_Zur_Messebeteiligung.schema.attributes.Angaben_Zur_Messebeteiligung_Pruefung_Ueberarbeitet_Am.path}
				erledigtPath={P.Angaben_Zur_Messebeteiligung.schema.attributes.Angaben_Zur_Messebeteiligung_Pruefung_Erledigt.path}
				formStruc={formStrucMesseBeschreibungPruefAssistenz()}
			/>
			<Grid2 container spacing={6}>
				<Grid2 sm={6}>
					<CreateForm
						formStruc={formStrucSpalte1()}
						formValues={application}
						updateFormValuesFunc={setApplicationProperty}
						readOnly={updatedReadOnly}
					/>
				</Grid2>
				<Grid2 sm={6}>
					<CreateForm
						formStruc={formStrucSpalte2(application)}
						formValues={application}
						updateFormValuesFunc={setApplicationProperty}
						readOnly={updatedReadOnly}
					/>
				</Grid2>
			</Grid2>
			<CreateForm
				formStruc={formStrucMesseTeilnahmen()}
				formValues={application}
				updateFormValuesFunc={setApplicationProperty}
				readOnly={updatedReadOnly}
			/>
		</>
	);
};

export default MessebeteiligungMessefoerderung;

const formStrucMesseBeschreibungPruefAssistenz = () => {
	let struc: FormStrucItem[] = [
		{
			fields: [
				{
					...P.Angaben_Zur_Messebeteiligung.schema.attributes.Angaben_Zur_Messebeteiligung_Pruefung_Erledigt,
					label: ALS_ERLEDIGT_MARKIEREN_LABEL,
					validation: [{ validateFunction: ForceTrue }],
				},
			],
		},
	];

	return struc;
};
const formStrucSpalte1 = () => {
	return [
		{
			fields: [
				P.Angaben_Zur_Messebeteiligung.schema.attributes.Projektbeschreibung_Messefoerderung_Messename,
				P.Angaben_Zur_Messebeteiligung.schema.attributes.Projektbeschreibung_Messefoerderung_Messeort,
				P.Angaben_Zur_Messebeteiligung.schema.attributes.Projektbeschreibung_Messefoerderung_Messeland,
				P.Angaben_Zur_Messebeteiligung.schema.attributes.Projektbeschreibung_Messefoerderung_International,
				P.Angaben_Zur_Messebeteiligung.schema.attributes.Projektbeschreibung_Messefoerderung_Messeart,
			],
			userProps: { direction: 'column', columnToDivide: 1 },
		},
	];
};
const formStrucSpalte2 = (application: any) => {
	return [
		{
			fields: [
				{
					...P.Angaben_Zur_Messebeteiligung.schema.attributes.Start,
					validation: [
						{ validateFunction: Required },
						{ validateFunction: ValidDate },
						{
							validateFunction: GetCompareMinMaxEqualDate,
							params: [
								P.Angaben_Zur_Messebeteiligung.schema.attributes.Projektbeschreibung_Messefoerderung_Zeitraum_Von.path,
								P.Angaben_Zur_Messebeteiligung.schema.attributes.Projektbeschreibung_Messefoerderung_Zeitraum_Bis.path,
							],
						},
					],
				},
				{
					...P.Angaben_Zur_Messebeteiligung.schema.attributes.Ende,
					validation: [
						{ validateFunction: Required },
						{ validateFunction: ValidDate },
						{
							validateFunction: GetCompareMinMaxEqualDate,
							params: [
								P.Angaben_Zur_Messebeteiligung.schema.attributes.Projektbeschreibung_Messefoerderung_Zeitraum_Von.path,
								P.Angaben_Zur_Messebeteiligung.schema.attributes.Projektbeschreibung_Messefoerderung_Zeitraum_Bis.path,
							],
						},
					],
				},
			],
			userProps: { columnToDivide: 2 },
		},
		{
			fields: [P.Angaben_Zur_Messebeteiligung.schema.attributes.Projektbeschreibung_Messefoerderung_Standflaecheqm],
			userProps: { columnToDivide: 1 },
		},
		{
			fields: [
				{
					...P.Angaben_Zur_Messebeteiligung.schema.attributes.Projektbeschreibung_Messefoerderung_Zeitraum_Von,
					validation: [
						{ validateFunction: Required },
						{ validateFunction: ValidDate },
						{ validateFunction: GetFutureDateValidation, params: [get(application, 'attributes.createdAt')] },
					],
				},
				{
					...P.Angaben_Zur_Messebeteiligung.schema.attributes.Projektbeschreibung_Messefoerderung_Zeitraum_Bis,
					validation: [
						{ validateFunction: Required },
						{ validateFunction: ValidDate },
						{
							validateFunction: GetDateGTMaxYearValidation,
							params: [P.Angaben_Zur_Messebeteiligung.schema.attributes.Projektbeschreibung_Messefoerderung_Zeitraum_Von.path, 10],
						},
					],
				},
			],
			userProps: { columnToDivide: 2 },
		},
		{
			fields: [P.Angaben_Zur_Messebeteiligung.schema.attributes.Projektbeschreibung_Messefoerderung_Messeanmeldung],
			userProps: { direction: 'column', columnToDivide: 1 },
		},
	];
};
// const formStrucFunction = () => {
// 	let struc: FormStrucItem[] = [
// 		{
// 			fields: [
// 				{
// 					...P.Angaben_Zur_Messebeteiligung.schema.attributes.Projektbeschreibung_Messefoerderung_Teilnehmende,
// 					validation: [{ validateFunction: NonRequired }],
// 				},
// 			],
// 			userProps: { direction: 'column', columnToDivide: 1 },
// 		},
// 	];
// 	return struc;
// };
const formStrucMesseTeilnahmen = () => {
	return [
		{
			fields: [
				{
					...P.Angaben_Zur_Messebeteiligung.schema.attributes.Projektbeschreibung_Messefoerderung_Messeteilnahmen,
					type: 'componentTable',
					tableLabel: 'Angabe der geförderten Messeteilnahmen in den letzten Jahren',
					width: 'fit-content',
				},
			],
			userProps: { columnToDivide: 1 },
		},
	];
};

export const getFormStrucMessebeteiligungMessefoerderung = (application: any) => {
	if (
		checkIfPruefAssitenzNeedsToValidate(
			application,
			P.Angaben_Zur_Messebeteiligung.schema.attributes.Angaben_Zur_Messebeteiligung_Pruefung_Pruefstatus.path,
			P.Angaben_Zur_Messebeteiligung.schema.attributes.Angaben_Zur_Messebeteiligung_Pruefung_Erledigt.path,
		)
	) {
		return concat(formStrucMesseBeschreibungPruefAssistenz(), formStrucSpalte1(), formStrucSpalte2(application));
	}
	return concat(formStrucSpalte1(), formStrucSpalte2(application));
};
